module.exports = __webpack_public_path__ + "static/media/bancoDoBrasil.8aa67841.png";